import { EHeaderStateActionTypes, IHeaderState, IHeaderStoreAction } from './types';

export const reducer = (
	{ searchShow, showLanguages }: IHeaderState,
	action: React.ReducerAction<React.Reducer<any, IHeaderStoreAction>>,
) => {
	const state = {
		searchShow: searchShowReducer(searchShow, action),
		showLanguages: showLanguagesReducer(showLanguages, action)
	}

	return state
}

const searchShowReducer = (state: boolean, action: IHeaderStoreAction) => {
	let newState = state
	switch (action.type) {
		case EHeaderStateActionTypes.UpdateSearchShow:
			newState = action.value
			break
		default:
			break
	}

	return newState
}

const showLanguagesReducer = (state: boolean, action: IHeaderStoreAction) => {
	let newState = state
	switch (action.type) {
		case EHeaderStateActionTypes.UpdateShowLanguages:
			newState = action.value
			break
		default:
			break
	}

	return newState
}